export const formatCurrency = (value: number, currency = "EUR", locale = "de-DE"): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
